import React from "react";
import Select from "react-select";

const SelectDropdown = ({
  value,
  onChange,
  options,
  placeholder = "Select",
  isMulti = false,
  isSearchable = true,
  closeMenuOnSelect = true,
  width = "100%",
}) => {
  const selectedOption = options.find((opt) => opt.value === value) || null;

  const customStyles = {
    container: (base) => ({
      ...base,
      width: width, // ✅ APPLY WIDTH HERE
    }),
    control: (base) => ({
      ...base,
      border: "1px solid #d1d5db",
      borderRadius: "10px",
      minHeight: "45px",
    }),

    /* Selected chip */
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#1a73e8",
      borderRadius: "12px",
      padding: "2px 4px",
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "#fff",
      fontWeight: 500,
      paddingRight: "4px",
    }),

    /* ✅ ONLY close (×) button show */
    multiValueRemove: (base) => ({
      ...base,
      color: "#fff",
      borderRadius: "50%",
      padding: "2px",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#dc3545",
        color: "#fff",
      },
    }),

    clearIndicator: () => ({
      // display: "none",
      padding: "2px",
    }),

    indicatorSeparator: () => ({
      // display: "none",
      padding: "4px",
    }),
  };

  return (
    <Select
      value={selectedOption}
      onChange={(option) => onChange(option ? option.value : null)}
      options={options}
      styles={customStyles}
      isClearable={true}
      placeholder={placeholder}
    />
  );
};

export default SelectDropdown;
